import { GetStaticProps } from 'next';
import { useSession } from 'next-auth/react';
import { useTranslation, withTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useEffect } from 'react';
import Spinner from '~/components/common/spinner';
import { defaultLocale } from '~/locale/defaults';
import { useStateValue } from '~/store/store';
import { markFlowStart } from '~/hooks/gtm/track-service-complete';
import Layout, { StepInfo } from '~/components/pay-fine/login/layout';
import PayFee from '~/components/pay-fine/guest/pay-fees';
import { useAuthentication } from '~/components/address-change/hook';

function PayFees() {
    const { status } = useSession();
    const { state } = useStateValue();
    const { t } = useTranslation();
    const { isGuestUser } = useAuthentication();

    useEffect(() => {
        markFlowStart();
    }, []);

    const stepInfo = {
        currentStep: 0,
        totalSteps: 0,
        prevUrl: isGuestUser ? `${t('common:ontarioCaUrl')}` : '/dashboard', // update this !!
        isPayfee: true,
    } as StepInfo;

    return (
        <Layout stepInfo={stepInfo} showCreateAccount={isGuestUser ? true : false}>
            <Spinner isLoading={status === 'loading' || state?.isLoading} />
            <PayFee />
        </Layout>
    );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? defaultLocale, [
            'pay-fine',
            'base-layout',
            'common',
            'help-chat',
            'session-timeout',
            'errors',
        ])),
    },
});

export default withTranslation([
    'pay-fine',
    'base-layout',
    'common',
    'session-timeout',
    'help-chat',
    'errors',
])(PayFees);
